var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.591,
    height: 22.591,
    viewBox: "0 0 22.591 22.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14284B",
    id: "Search",
    d: "M20.35,18.413H19.33l-.362-.349a8.409,8.409,0,1,0-.9.9l.349.362v1.02L24.871,26.8,26.8,24.871Zm-7.75,0A5.812,5.812,0,1,1,18.413,12.6,5.8,5.8,0,0,1,12.6,18.413Z",
    transform: "translate(-4.204 -4.204)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ad2bdcd2306ad452cd63c138bb7dea28.svg";
export { ForwardRef as ReactComponent };